import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TransporteurSelect from './TransporteurSelect';
import { fetchTransporteurs } from 'store/transporteur/transporteurActions';

class TransporteurSelectContainer extends React.Component {
    componentDidMount() {
        this.props.fetchTransporteurs();
    }

    render() {
        const { transporteurs, value, isLoading, onChange, all, excluded, isRequired, error, disabled } = this.props;

        return (
            <TransporteurSelect transporteurs={transporteurs}
                value={value}
                isLoading={isLoading}
                onChange={onChange}
                all={all}
                excluded={excluded}
                error={error}
                isRequired={isRequired}
                disabled={disabled ? disabled === true : false}
            />
        );
    }
}

const mapStateToProps = state => ({
    transporteurs: state.transporteur.transporteurs.items,
    isLoading: state.transporteur.transporteurs.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchTransporteurs: () => dispatch(fetchTransporteurs())
});

TransporteurSelectContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    all: PropTypes.bool.isRequired,
    excluded: PropTypes.number,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    disabled: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(TransporteurSelectContainer);